import { useEffect } from "react";

import {
  clearPageValuesFromDataLayer,
  DATA_LAYER_SCOPES,
  pushPageValuesToDataLayer
} from "seneca-common/features/analytics";

import useCache from "../useCache";

export { DATA_LAYER_SCOPES };

export default function usePushStaticPageValuesToAnalyticsDataLayer(
  dataLayerScope: string,
  values: Record<string, any>
) {
  // We use a cache to store the last values we pushed to the data layer
  // we use this to only push changes when a value has changed.
  const { replaceCache, getUpdatedValues } = useCache();

  const updatedValues = getUpdatedValues(values);

  if (Object.keys(updatedValues).length > 0) {
    pushPageValuesToDataLayer({
      [dataLayerScope]: updatedValues
    });
  }

  replaceCache(values);

  useEffect(() => {
    return () => {
      clearPageValuesFromDataLayer({
        [dataLayerScope]: values
      });
    };
  }, [dataLayerScope]); // eslint-disable-line react-hooks/exhaustive-deps
}
